import CSV from '../assets/images/cvs-icon.png';
import DOC from '../assets/images/doc-icon.png';
import JPG from '../assets/images/jpg-icon.png';
import PDF from '../assets/images/pdf -icon.png';
import PNG from '../assets/images/png-icon.png';

export const ImageMappingForDragAndDrop = {
    'IMAGE_CSV' : CSV,
    'IMAGE_DOC' : DOC,
    'IMAGE_JPG' : JPG,
    'IMAGE_PDF' : PDF,
    'IMAGE_PNG' : PNG,
}